import React, { useContext, useRef, useState, useMemo } from 'react'
import ModalWindow from 'components/ModalWindow'
import { Button, Icon, Popup } from 'semantic-ui-react'
import { injectIntl } from 'react-intl'
import { UserContext, NotifyContext } from 'context'

import api from 'actions/api'

import doRequest from 'actions/doRequest'

function ApplicationsCalendarDayBlockingModal(props) {
    const { dayDate, isDayBlocked = false, intl, reloadApp, withoutLabel = false } = props
    const { logout } = useContext(UserContext)

    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const abortRequestRef = useRef(null)

    const { pushNotify } = useContext(NotifyContext)

    const translates = useMemo(() => ({
        blockDay: intl.formatMessage({ id: 'btn.blockDay' }),
        unlockDay: intl.formatMessage({ id: 'btn.unlockDay' }),
        dayBlockingMsg: intl.formatMessage({ id: 'msg.dayBlocking' }),
        dayUnlockingMsg: intl.formatMessage({ id: 'msg.dayUnlocking' }),
        yes: intl.formatMessage({ id: 'btn.yes' }),
        no: intl.formatMessage({ id: 'btn.no' }),
        confirmActionTitle: intl.formatMessage({ id: 'title.confirmAction' })
    }), [intl.locale]) // eslint-disable-line react-hooks/exhaustive-deps

    const getButtons = () => [
        { title: translates.yes, onClick: updateDay, disabled: loading, loading: loading },
        { title: translates.no, onClick: () => setOpen(false), disabled: false, loading: false },
    ]

    const openModal = () => {
        setOpen(true)
    }

    const closeModal = () => {
        setOpen(false)
    }

    const updateDay = () => {
        setLoading(true)

        const req = doRequest(api.blockedDays.addUpdateDay({ dayDate, dontUpdate: false }), pushNotify, logout)
        abortRequestRef.current = req.abort

        req.ready.then(data => {
            if (data) {
                pushNotify('success', 'title.success', 'msg.sendRequstSuccess', 2000)
            }
        }).catch(console.error)
            .finally(() => {
                setLoading(false)
                closeModal()
                reloadApp()
            })

    }

    return (
        <ModalWindow
            closeIcon
            size="tiny"
            iconType="info"
            title={translates.confirmActionTitle}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => openModal()}
            trigger={
                withoutLabel ?
                    <Button className="actionButton" icon> <Popup inverted content={isDayBlocked ? translates.unlockDay : translates.blockDay} trigger={<Icon name={isDayBlocked ? "lock" : "lock open"} />} /></Button>
                    :
                    <Button className="actionButton" icon><Icon name={isDayBlocked ? "lock" : "lock open"} />
                        <span>{isDayBlocked ? translates.unlockDay : translates.blockDay}</span>
                    </Button>
            }
            actions={getButtons()}
        >
            <div className="applicationDayBlock">
                <h3>{isDayBlocked ? translates.dayUnlockingMsg : translates.dayBlockingMsg}</h3>
            </div>
        </ModalWindow>
    )
}

export default injectIntl(ApplicationsCalendarDayBlockingModal)